'use strict';

var _ = require('lodash');
var d3tip = require('d3-tip');
var Tooltip = function Tooltip() {
  var exp = _.template(require('../templates/tooltip-template.html'));
  return function (tooltipClass) {
    return d3tip().attr('class', 'd3-tip' + (tooltipClass ? ' ' + tooltipClass : '')).html(exp);
  };
};
Tooltip.$inject = [];
module.exports = Tooltip;